import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { JwtHelperService } from '@auth0/angular-jwt';
import { Storage } from '@ionic/storage';
import { Observable, ReplaySubject } from 'rxjs';
import { tap } from 'rxjs/operators';
import { SERVER_API_URL, TOKEN_NAME } from '../../app/config';

@Injectable()
export class AuthProvider {
  private jwtTokenName = `${TOKEN_NAME}`;
  authUser = new ReplaySubject<any>(1);
  userData = new ReplaySubject<any>(1);

  constructor(
    private readonly httpClient: HttpClient,
    private readonly storage: Storage,
    private readonly jwtHelperSvc: JwtHelperService
  ) {}

  checkLogin() {
    this.storage.get(this.jwtTokenName).then((jwt) => {
      if (jwt && !this.jwtHelperSvc.isTokenExpired(jwt)) {
        this.authUser.next(jwt);
        this.userData.next(this.jwtHelperSvc.decodeToken(jwt).data);
        // this.locationTracker.startTracking();
      } else {
        this.authUser.next(null);
        this.userData.next(null);
      }
    });
  }

  login(data: any): Observable<any> {
    //login function
    return this.httpClient.post(`${SERVER_API_URL}/auth`, data, { responseType: 'json' }).pipe(
      tap((response) => {
        this.handleJwtResponse(response.data);
      })
    );
  }

  logout() {
    //logout function
    return this.storage.remove(this.jwtTokenName).then(() => {
      this.authUser.next(null);
      this.userData.next(null);
    });
  }

  private handleJwtResponse(jwt: string) {
    return this.storage
      .set(this.jwtTokenName, jwt)
      .then(() => {
        this.authUser.next(jwt);
        this.userData.next(this.jwtHelperSvc.decodeToken(jwt).data);
      })
      .then(() => jwt);
  }

  authGuard(menu) {
    let allowed: boolean = false;
    this.userData.subscribe(
      (res: any) => {
        if (res !== null) {
          res.role.menus.forEach((element) => {
            if (element === menu) {
              allowed = true;
            }
          });
          return allowed;
        } else {
          return false;
        }
      },
      (error) => {
        return false;
      }
    );
  }
}



// WEBPACK FOOTER //
// ./src/providers/auth/auth.ts